import React from 'react'
import redirector from '../../components/redirector'
import { UserProfileWrapper } from '../../components/account/styles'
import { BubbleLink } from '../../styles/Components'
import { useRouter } from 'next/router'
import { useUserContext } from '../../components/UserContext'
import LoadingStep from '../../components/book/steps/components/LoadingStep'
import Link from 'next/link'
import Head from 'next/head'
import { useProtectedRoute } from '../../helpers'

export default redirector('/account/details')

export const AccountLayout = ({ children }) => {
  const { pathname } = useRouter()
  const { user } = useUserContext()

  const selectedTab = pathname.split('/')[pathname.split('/').length - 1]
  const subpath = pathname.split('/account/')[1]
  useProtectedRoute(`/signin?onSuccess=/account/${subpath}`)

  // in progress for rebrand

  let tabs = [
    { tab: 'details', text: 'My Account' },
    { tab: 'appointments', text: 'My Appointments' },
    { tab: 'membership', text: 'Membership' },
    { tab: 'credits', text: 'Credits' },
    { tab: 'invite-friends', text: 'Invite Friends' },
  ]

  if (user && !user.memberships?.length) {
    tabs = tabs.filter(tab => tab.tab !== 'membership')
  }

  return (
    <UserProfileWrapper>
      <Head>
        <title>Account | Glamsquad</title>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      {user ? (
        <>
          <div className='tabs-wrapper'>
            <div
              className="user-settings-tabs"
              data-testid="user-settings-tabs"
              id="main-content"
              tabIndex="0"
            >
              {tabs.map((t, i) => (
                <Link
                  key={i}
                  data-testid={`${t.tab}-account-tab`}
                  href={`/account/${t.tab}`}
                >
                  <BubbleLink
                    className={
                      t.tab === selectedTab
                        ? 'selected'
                        : ''
                    }
                  >
                    {t.text}
                  </BubbleLink>
                </Link>
              ))}
            </div>
          </div>
          {children}
        </>
      ) : (
        <LoadingStep />
      )}
    </UserProfileWrapper>
  )
}
